import { TableFrame, Th, Td, NumTd } from './TableFrame';
import { num, pct, times } from './format';
import type { ReportLine } from './types';

interface TroubleshooterTableProps {
  lines: ReportLine[];
}

/** DV360 troubleshooter funnel per line: why each auction is won or lost. */
export function TroubleshooterTable({ lines }: TroubleshooterTableProps) {
  return (
    <div className="space-y-3">
      <TableFrame
        head={
          <>
            <Th>Línea</Th>
            <Th numeric>Elegibles</Th>
            <Th numeric>Pujas</Th>
            <Th numeric>Respuestas</Th>
            <Th numeric>Ganadas</Th>
            <Th numeric>Win rate</Th>
            <Th numeric>Bajo suelo</Th>
            <Th numeric>Bid too low</Th>
            <Th numeric>Fren. pacing</Th>
            <Th numeric>Fren. presup.</Th>
            <Th numeric>Holgura</Th>
            <Th numeric>Sin crea.</Th>
          </>
        }
      >
        {lines.map((line) => {
          const funnel = line.ts;
          if (!funnel) {
            return (
              <tr key={line.id}>
                <Td className="font-bold">{line.name}</Td>
                <Td colSpan={11} className="text-adv-tertiary">
                  Sin fichero del troubleshooter en GCS para ese día
                </Td>
              </tr>
            );
          }
          return (
            <tr key={line.id} className="hover:bg-adv-sunken">
              <Td className="font-bold whitespace-nowrap">{line.name}</Td>
              <NumTd>{num(funnel.eligible)}</NumTd>
              <NumTd>{num(funnel.bids)}</NumTd>
              <NumTd>{num(funnel.responses)}</NumTd>
              <NumTd>{num(funnel.won)}</NumTd>
              <NumTd>{pct(funnel.win_rate)}</NumTd>
              <NumTd>{pct(funnel.below_min_pct)}</NumTd>
              <NumTd>{pct(funnel.bid_too_low_pct)}</NumTd>
              <NumTd>{num(funnel.pacing_limited)}</NumTd>
              <NumTd>{num(funnel.budget_limited)}</NumTd>
              <NumTd>{times(funnel.headroom)}</NumTd>
              <NumTd>{num(funnel.no_creative)}</NumTd>
            </tr>
          );
        })}
      </TableFrame>
      <p className="text-adv-body-s text-adv-tertiary">
        Win rate = ganadas ÷ respuestas · Bajo suelo = % de pujas por debajo de la puja mínima · Bid
        too low = % de respuestas perdidas en el exchange por puja baja · Fren. = impresiones
        elegibles frenadas por pacing o presupuesto · Sin crea. = impresiones sin creatividad
        elegible
      </p>
    </div>
  );
}
